import React, { useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import AdvancedHotkey from './component';
import { useIsQuickshipAllowed } from '../../../hooks/use-seller-setting';
import { useOnToggleQuickship } from '../../../hooks/use-user-setting';

export const messages = defineMessages({
  name: {
    description: 'toggle quickship hotkey',
    defaultMessage: 'Toggle QuickShip',
    id: 'JGF1wr',
  },
});

export const hotkey = ['q'];
export const barcodeContent = '+T42FP8GFMAEK=';

const ToggleQuickshipHotkey = ({ children }) => {
  const shouldDisableHotkey = !useIsQuickshipAllowed();
  const intl = useIntl();
  const onUpdate = useOnToggleQuickship();
  const hotkeyMetadata = useMemo(
    () => ({
      barcode: barcodeContent,
      displayHotkeyStrings: ['q'],
      hotkey,
      handler: onUpdate,
      name: intl.formatMessage(messages.name),
      legacyCategory: 'shipping',
      doNotTrack: false,
    }),
    [intl, onUpdate],
  );

  if (shouldDisableHotkey) {
    return children;
  }
  return <AdvancedHotkey hotkey={hotkeyMetadata}>{children}</AdvancedHotkey>;
};

ToggleQuickshipHotkey.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ToggleQuickshipHotkey;
